<template>
    <page title="dashboardTitle">
        <template #pageContainer>
            <div v-if="!IsAuthenticated">
                <p>Willkommen beim Seltec Portal.</p>
                <p>
                    Bitte loggen Sie sich ein (mit Ihren Zugangsdaten für LA.Net oder das Portal).
                </p>
                <p>Haben Sie noch keine Zugangsdaten, so registrieren Sie sich bitte neu.</p>

                <page-sub-title :title="'loginTitle'" :info="''"></page-sub-title>
                <login></login>
            </div>
            <div v-else>
                <p>
                    Wenn Sie sich mit Ihrem LA.Net Zugang hier am Portal angemeldet haben,
                    können Sie unter „Lizenz“ Ihre Lizenz für TAF 3 herunterladen.
                </p>
                <p>
                    Haben Sie sich direkt hier im Portal registriert,
                    oder sehen Sie den "Lizenz" Menüpunkt nicht,
                    so müssen Sie erst eine Benutzerrolle für Ihren Verein beantragen.
                </p>
                <p>
                    Wurde diese Rolle vom zuständigen LV bestätigt,
                    können auch Sie sich unter „Lizenz“ Ihre Lizenz für TAF 3 herunterladen.
                </p>
            </div>
        </template>
    </page>
</template>

<script>
import { mapGetters } from 'vuex';
import Page from '../general/Page.vue';
import namespace from '../store/namespace';

import PageSubTitle from '../general/PageSubTitle.vue';
import Login from '../auth/Login.vue';

export default {
	name: 'Dashboard',
	components: {
		Page,
		PageSubTitle,
		Login,
	},
	computed: {
		...mapGetters(namespace.AUTH, ['IsAuthenticated']),
        ...mapGetters(namespace.USER, ['User']),
	},
    mounted() {
		console.log(this.User)
        if (this.User.languageCode == 'de'){
            this.$i18n.locale = 'gr';
        } else if (this.User.languageCode == 'en'){
            this.$i18n.locale = 'en';
        }
	},
};
</script>
